<mat-form-field  appearance="outline" [matBadge]="badge"  style="width: 220px !important;" >
  <mat-label>{{placeholder}}</mat-label>
  <input  matInput #inputField   disabled />
  <input
    style="color: white; width: 0px !important"
    matInput [matDatepicker]="picker" [min]="min" (dateChange)="updateValue($event)" disabled [(ngModel)]="inputValue" />
    <mat-datepicker #picker disabled="false"></mat-datepicker>
    <div matSuffix class="suffix-container">
      <mat-datepicker-toggle [for]="picker"></mat-datepicker-toggle>   
      @if (inputValue && clearable) {
        <button mat-icon-button aria-label="Clear"
          (click)="clear()">
          <mat-icon>close</mat-icon>
        </button>
      }
    </div>
</mat-form-field>

